const TWO_PI = Math.PI * 2;

/**
 * converts to radians, then normalizes the angle between -π and π.
 *
 * Numbers must be inversed because JavaScript sees positive values as clockwise,
 * but iOS sees positive values as counter-clockwise. Since mobile finished their
 * work first, we're inversing our numbers on web to match their values.
 */
export const degreesToRadians = (degrees: number) => {
  const radians = degrees * (Math.PI / 180);
  return -(radians - TWO_PI * Math.floor((radians + Math.PI) / TWO_PI));
};

/**
 * converts that inverse value back to what JavaScript wants to see
 *
 * @see degreesToRadians
 */
export const radiansToDegrees = (radians: number) => -(radians * (180 / Math.PI));
